const PromiseSection = () => {
  return (
    <section id="promesse" className="py-20 sm:py-28 px-6 bg-[#56433e]">
      <div className="max-w-2xl mx-auto text-center space-y-8 text-[#F3E5CF]">
        
        {/* Premium micro-heading structure */}
        <div className="space-y-3">
          <p className="text-[10px] sm:text-xs tracking-[0.3em] uppercase text-[#C5A059]">
            La promesse
          </p>
          <h2 
            className="font-serif text-3xl sm:text-4xl md:text-5xl text-[#F3E5CF]"
            style={{ textWrap: 'balance' }}
          >
            Un passage.
          </h2>
          <p 
            className="font-serif text-sm sm:text-base text-[#F3E5CF]/70 italic"
            style={{ textWrap: 'balance' }}
          >
            Pas un séjour. Une transformation.
          </p>
        </div>
        
        <div className="w-16 h-[1px] bg-[#C5A059]/70 mx-auto" />
        
        <div className="space-y-6 text-base sm:text-lg leading-[1.9]">
          <p style={{ textWrap: 'balance' }}>
            COCON n'est pas un simple séjour.
          </p>
          <p 
            className="font-medium"
            style={{ textWrap: 'balance' }}
          >
            C'est un cycle de transformation qui se déploie en trois temps.
          </p>
          
          <div className="py-6 space-y-2 text-xl sm:text-2xl font-serif">
            <p>Avant.</p>
            <p>Pendant.</p>
            <p>Après.</p>
          </div>
          
          <p 
            className="italic"
            style={{ textWrap: 'balance' }}
          >
            Chaque étape soutient un déplacement intérieur réel.
          </p>
          <p 
            className="italic mt-2"
          >
            Et rien ne se fait à distance.
          </p>
        </div>
      </div>
    </section>
  );
};

export default PromiseSection;
